module.exports = __webpack_public_path__ + "static/media/bmsd.e5e8cc5d.jpeg";